import clsx from 'clsx';
import styles from './index.module.scss';
import { FC, useEffect } from 'react';
import NextErrorProps from '@/types/next-error-props.type';
import Button from '@/components/shared/Button';
import UIVariant from '@/enums/ui-variant.enum';
import UISize from '@/enums/ui-size.enum';
import AppLogo from '@/components/AppLogo';
import { useRouter } from 'next/navigation';
const ErrorContainer: FC<NextErrorProps> = ({ error }) => {
  const router = useRouter();

  useEffect(() => {
    console.error(error);
  }, [error]);

  return (
    <div className={clsx(styles.wrapper, 'vertical-center')}>
      <AppLogo className={styles.wrapper__logo} size={UISize.LARGE} />
      <h2 className={styles.wrapper__title}>Bir hata oluştu!</h2>
      <p className={styles.wrapper__error}>
        <strong>
          <i>Error: {error.message}</i>
        </strong>
      </p>
      <div className={clsx(styles.wrapper__actions, 'horizontal-center')}>
        <Button variant={UIVariant.BLUE} onClick={router.refresh}>
          Sayfayı Yenile
        </Button>
        <Button variant={UIVariant.PRIMARY} onClick={() => router.push('/')}>
          Ana Sayfa
        </Button>
      </div>
    </div>
  );
};
export default ErrorContainer;
